import {Component, EventEmitter, Input, OnInit, Output, OnDestroy, AfterViewInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Observable} from "rxjs/Observable";
import {
    FORM_DIRECTIVES,
    FORM_PROVIDERS,
    REACTIVE_FORM_DIRECTIVES,
    FormControl,
    FormGroup,
    Validators
} from "@angular/forms";
import {AlertComponent, TYPEAHEAD_DIRECTIVES, MODAL_DIRECTIVES, BS_VIEW_PROVIDERS} from "ng2-bootstrap/ng2-bootstrap";
import {ContractsService} from "../service/contracts.service";
import {VehiclesService} from "../service/vehicles.service";
import {BankService} from "../service/bank.service";
import {CitiesService} from "../service/cities.service";
import {Vehicle} from "../domain/vehicle";
import {Contract} from "../domain/contract";
import {Contact} from "../domain/contact";
import {Bank} from "../domain/bank";
import {Address} from "../domain/address";
import {City} from "../domain/city";
import {State} from "../domain/state";
import {
    INTEGER_VALIDATOR, DEFAULT_ERROR_MESSAGES, EMAIL_VALIDATOR, DATE_VALIDATOR,
    DATE_VALID_CHARACTERS
} from "../validators/validators";
import {PaginatePipe, PaginationControlsCmp, PaginationService} from "ng2-pagination";
import {Page} from "../domain/page";
import {LoginService} from "../service/login.service";

@Component({
    selector: 'contract-editor',
    template: require('./contract.editor.component.html'),
    styles: [require('./contract.editor.component.css')],
    directives: [
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        AlertComponent,
        TYPEAHEAD_DIRECTIVES,
        /*MyDatePicker,*/
        PaginationControlsCmp,
        MODAL_DIRECTIVES
    ],
    providers: [
        FORM_PROVIDERS,
        PaginationService,
        BS_VIEW_PROVIDERS
    ],
    pipes: [PaginatePipe]
})
export class ContractEditorComponent implements OnInit, OnDestroy, AfterViewInit {

    @Input() public contract:Contract;
    @Output() close = new EventEmitter();

    public error:any;
    private sub:any;

    public errorMessages:any;

    public form:FormGroup;

    public banks:Bank[];
    public cities:City[];
    public states:State[];

    public createMode:boolean;

    private contractId:string;

    /*myDatePickerOptions:any;*/

    public errorMessage:string;
    public successMessage:string;

    public loading:boolean;

    public stateSelected:State;
    public contact:Contact;

    public vehicles:Vehicle[];
    public vehicleSelected:Vehicle;

    public contractStateSelectedId:string;
    public contractCitySelectedId:string;

    private currentPage:Page;
    public itemsPerPage:number;
    public page:number;
    public total:number;

    public canEdit:boolean;
    public canEditVehicle:boolean;
    public canDeleteVehicle:boolean;
    public canViewVehicle:boolean;

    public contractValid:boolean;

    constructor(private contractsService:ContractsService,
                private vehiclesService:VehiclesService,
                private bankService:BankService,
                private citiesService:CitiesService,
                private router:Router,
                private route:ActivatedRoute,
                private loginService:LoginService) {
        this.init();
    }

    private init():void {
        this.errorMessages = DEFAULT_ERROR_MESSAGES;

        this.loading = false;

        this.contract = new Contract(null);
        this.contract.bank = new Bank();

        this.stateSelected = new State();
        this.contact = new Contact();

        this.vehicles = [];

        this.itemsPerPage = 5;
        this.page = 1;
        this.total = 0;

        this.canEdit = false;
        this.canEditVehicle = false;
        this.canDeleteVehicle = false;
        this.canViewVehicle = false;

        this.contractValid = false;
    }

    private createFormGroup():void {
        this.form = new FormGroup({
            contractNumber: new FormControl(this.contract.contractNumber, [Validators.required]),
            cuit: new FormControl(this.contract.cuit, [Validators.required]),
            bank: new FormControl(this.contract.bank.id, [Validators.required]),
            businessName: new FormControl(this.contract.businessName, [Validators.required]),
            phone: new FormControl(this.contract.phone),
            street: new FormControl(this.contract.address.street),
            number: new FormControl(this.contract.address.number, [INTEGER_VALIDATOR]),
            floor: new FormControl(this.contract.address.floor),
            department: new FormControl(this.contract.address.department),
            zipCode: new FormControl(this.contract.address.zipCode, [INTEGER_VALIDATOR]),
            city: new FormControl(this.contract.address.city.name),
            state: new FormControl(this.stateSelected.name),
            contactName: new FormControl(this.contact.name),
            contactPhone: new FormControl(this.contact.phone),
            contactEmail: new FormControl(this.contact.email, [Validators.required, EMAIL_VALIDATOR]),
            dueDate: new FormControl(this.contract.dueDate, [DATE_VALID_CHARACTERS, DATE_VALIDATOR])
        });
    }

    public ngOnInit() {
        let userLogged = this.loginService.getUserLogged();
        this.canEdit = userLogged.isActionAllowed('CONTRACTS', 'EDIT', 'CONTRACTS');
        this.canEditVehicle = userLogged.isActionAllowed('CONTRACTS', 'EDIT', 'VEHICLES');
        this.canDeleteVehicle = userLogged.isActionAllowed('CONTRACTS', 'DELETE', 'VEHICLES');
        this.canViewVehicle = userLogged.isActionAllowed('CONTRACTS', 'VIEW', 'VEHICLES');

        /*this.myDatePickerOptions = {dateFormat: 'dd/mm/yyyy'};*/

        this.createFormGroup();

        this.sub = this.route.params.subscribe(params => {
            let contractId = params['contractId'];
            if (contractId) {
                this.createMode = false;
                this.contractId = contractId;
            } else {
                this.createMode = true;
            }
            this.getData();
        });
    }

    public ngAfterViewInit() {
    }

    private getData():void {
        this.loading = true;

        let forkTasks:Observable<any>[] = [];
        forkTasks.push(this.bankService.getBanks());
        forkTasks.push(this.citiesService.getStates());
        if (this.contractId) {
            forkTasks.push(this.contractsService.getContract(this.contractId));
        }
        Observable.forkJoin(forkTasks).subscribe(
            this.setData.bind(this),
            () => {
                this.bindError('Ocurrió un error al obtener los datos del contrato.')
            });
        this.loading = false;
    }

    private setData(data:any[]):void {
        this.banks = data[0];
        this.states = data[1];
        if (this.contractId) {
            this.contract = data[data.length - 1];
            if (!this.contract.contacts || this.contract.contacts.length == 0) {
                this.contact = new Contact();
            } else {
                this.contact = this.contract.contacts[0];
            }
            if (!this.contract.bank) {
                this.contract.bank = new Bank(null);
                this.contract.bank.id = '';
            }
            if (!this.contract.address) {
                this.contract.address = new Address(null);
                this.contract.address.street = '';
            } else if (this.contract.address.city && this.contract.address.city.state) {
                this.contractStateSelectedId = this.contract.address.city.state.id;
                this.contractCitySelectedId = this.contract.address.city.id;
                this.loadCities(this.contract.address.city.state);
            }
            this.getVehicles(1);
            this.contractValid = true;
        } else {
            this.createContract();
        }
    }

    private createContract():void {
        this.contract = new Contract();
        this.contract.address.street = '';

        this.contractStateSelectedId = null;
        this.contractCitySelectedId = null;
    }

    private updateViewAfterSave():void {
        if (this.createMode) {
            /*this.createContract();*/
            /*this.contact = new Contact();*/
        }
    }

    private loadCities(state:State):void {
        if (state && state.id) {
            this.loading = true;
            this.citiesService.getCities(state.id)
                .subscribe(
                    (data:City[]) => {
                        this.loading = false;
                        this.cities = data;
                    },
                    () => {
                        this.bindError('Ocurrió un error al cargar las ciudades.');
                    });
        }
    }

    public ngOnDestroy() {
        this.sub.unsubscribe();
    }

    private clearMessages():void {
        this.successMessage = null;
        this.errorMessage = null;
    }

    public save():void {
        this.clearMessages();
        this.loading = true;

        this.contract.contacts = [this.contact];
        this.contractsService.save(this.contract).subscribe(
            (saved:Contract) => {
                this.loading = false;
                this.contract = saved;
                this.successMessage = 'El contrato se guardó con éxito';
                this.updateViewAfterSave();
            },
            () => {
                this.bindError('Ocurrió un error al guardar la información.');
            });
    }

    public goBack(event:any):void {
        event.preventDefault();
        this.close.emit(this.contract);
        this.router.navigate(['app/home/']);
        /*window.history.back();*/
    }

    private clearCity(state:State):void {
        this.contract.address.city = new City(null);
        this.contract.address.city.state = state;
        /*this.address.city = new City(null);*/
    }

    public getVehicles(page:number):void {
        this.error = null;
        if (this.contract.id) {
            this.loading = true;
            this.contractsService.getVehicles(this.contract.id, page, this.itemsPerPage)
                .subscribe((data) => {
                        this.refreshVehicles(data);
                        this.page = page;
                    },
                    () => {
                        this.bindError('Ocurrió un error al obtener los vehículos.');
                    });
        }
    }

    private refreshVehicles(page:Page) {
        this.vehicles = page.content;
        this.currentPage = page;
        this.total = page.totalElements;
        this.loading = false;
    }

    public removeVehicle(deleteModal:any, event:any):void {
        event.preventDefault();
        this.error = null;

        this.vehiclesService.delete(this.contract.id, this.vehicleSelected.id).subscribe(
            () => {
                deleteModal.hide();
                this.removeVehicleFromView(this.vehicleSelected);
            },
            () => {
                this.bindError('Ocurrió un error al eliminar vehículo');
            });
    }

    public removeVehicleFromView(vehicle:Vehicle):void {
        let index = this.vehicles.indexOf(vehicle);
        if (index > -1) {
            this.vehicles.splice(index, 1);
        }
        this.vehicleSelected = null;
    }

    public editVehicle(item:Vehicle, event:any):void {
        event.preventDefault();
        this.router.navigate(['app/home/editVehicle', this.contract.id, item.id, true]);
    }

    public createVehicle(event:any):void {
        event.preventDefault();
        this.router.navigate(['app/home/createVehicle', this.contract.id]);
    }

    public validateContract(event:any):void {
        if (this.contract.contractNumber && (event != null || this.contract.bank.id)) {
            if (event != null) {
                this.contract.bank = this.banks.find(bank => bank.id == event);
            }

            this.contractsService.getContractByContractNumberAndBank(this.contract.contractNumber, this.contract.bank.id)
                .subscribe(
                    (contract)=> {
                        if (contract && contract.id) {
                            this.contractValid = (this.contract.id == contract.id) ? true : false;
                        } else {
                            this.contractValid = true;
                        }
                    },
                    () => {
                        this.bindError('Ocurrió un error al validar contrato.');
                        this.contractValid = false;
                    });
        }
    }

    public onStateSelected(newValue:any):void {
        let result = this.states.filter(function (obj:State) {
            return obj.id == newValue;
        });
        if (result.length > 0) {
            this.loadCities(result[0]);
            this.clearCity(result[0]);
        }
    }

    public onCitySelected(newValue:any):void {
        let result = this.cities.filter(function (obj:City) {
            return obj.id == newValue;
        });
        if (result.length > 0) {
            this.contract.address.city = result[0];
        }
    }

    private bindError(messageError:string):void {
        this.loading = false;
        if (this.errorMessage == null) {
            this.errorMessage = messageError;
        } else {
            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
        }
    }

    /* Descomentar si se necesitan inputs (typeahead) y reemplazarlos por los actuales
     onStateSelected(state:any) {
     this.stateSelected = state.item;
     this.loadCities(this.stateSelected);
     this.clearCity();
     }

     onCitySelected(city:any) {
     this.address.city = city.item;
     }*/
}


/** WEBPACK FOOTER **
 ** ./src/app/contracts/contract.editor.component.ts
 **/